import React, { useState } from 'react';
import {
	IconButton,
	Menu,
	MenuItem,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	TextField,
	Button,
	Typography,
    Box,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AnnotatorField from "./AnnotatorField";

export default function OptionsMenu({ onRename, onDelete, annotators = [], parentLevelAnnotators = [], fileLevelAnnotators = [], allUsers = [], isAdmin = false, isAdminMode = false, onAnnotatorsChange }) {
	const [anchorEl, setAnchorEl] = useState(null);
	const [isRenameOpen, setIsRenameOpen] = useState(false);
	const [isDeleteOpen, setIsDeleteOpen] = useState(false);
	const [newName, setNewName] = useState('');
	const [isAnnotatorsOpen, setIsAnnotatorsOpen] = useState(false);

	const open = Boolean(anchorEl);

	const handleMenuOpen = (event) => {
        event.stopPropagation();
		setAnchorEl(event.currentTarget);
	};
	const handleMenuClose = (event) => {
        if (event) event.stopPropagation();
		setAnchorEl(null);
	};

	const handleRenameClick = (event) => {
        event.stopPropagation();
		setIsRenameOpen(true);
		handleMenuClose();
	};
	const handleDeleteClick = (event) => {
        event.stopPropagation();
		setIsDeleteOpen(true);
		handleMenuClose();
	};

	const handleRenameConfirm = (event) => {
        event.stopPropagation();
		// Pass newName back to parent or perform rename logic here
		if (onRename) {
			onRename(newName);
		}
		setNewName('');
		setIsRenameOpen(false);
	};
	const handleDeleteConfirm = (event) => {
        event.stopPropagation();
		// Perform delete logic here
		if (onDelete) {
			onDelete();
		}
		setIsDeleteOpen(false);
	};

	const handleRenameCancel = (event) => {
        event.stopPropagation();
		setNewName('');
		setIsRenameOpen(false);
	};
	const handleDeleteCancel = (event) => {
        event.stopPropagation();
		setIsDeleteOpen(false);
	};

	return (
		<Box component="span" display="inline-flex" onClick={(e) => e.stopPropagation()}>			
            <IconButton
                size="small"
				aria-label="more options"
				aria-controls={open ? 'options-menu' : undefined}
				aria-haspopup="true"
				onClick={handleMenuOpen}
                sx={{padding: 0}}
			>
				<MoreVertIcon />
			</IconButton>

			<Menu
				id="options-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleMenuClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
			>
				<MenuItem onClick={handleRenameClick}>Rename</MenuItem>
				<MenuItem onClick={handleDeleteClick}>Delete</MenuItem>
				{isAdminMode && (
					<MenuItem onClick={(e) => { e.stopPropagation(); setIsAnnotatorsOpen(true); handleMenuClose(); }}>
						Edit Annotators
					</MenuItem>
				)}
			</Menu>

			{/* Rename Dialog */}
			<Dialog open={isRenameOpen} onClose={handleRenameCancel}>
				<DialogTitle>Rename Item</DialogTitle>
				<DialogContent>
					<TextField
						autoFocus
						margin="dense"
						label="New name"
						fullWidth
						value={newName}
						onChange={(e) => setNewName(e.target.value)}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleRenameCancel}>Cancel</Button>
					<Button
						onClick={handleRenameConfirm}
						disabled={newName.trim().length === 0}
					>
						Rename
					</Button>
				</DialogActions>
			</Dialog>

			{/* Delete Confirmation Dialog */}
			<Dialog open={isDeleteOpen} onClose={handleDeleteCancel}>
				<DialogTitle>Confirm Delete</DialogTitle>
				<DialogContent>
					<Typography>
						Are you sure you want to delete this item?
					</Typography>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleDeleteCancel}>Cancel</Button>
					<Button color="error" onClick={handleDeleteConfirm}>
						Delete
					</Button>
				</DialogActions>
			</Dialog>
			<Dialog open={isAnnotatorsOpen} onClose={() => setIsAnnotatorsOpen(false)}>
				<DialogTitle>Edit Annotators</DialogTitle>
				<DialogContent>
					<AnnotatorField
						parentLevelAnnotators={parentLevelAnnotators}
						currentLevelAnnotators={annotators}
						fileLevelAnnotators={fileLevelAnnotators}
						allUsers={allUsers}
						isAdmin={isAdmin && isAdminMode}
						onChange={(user, isAdd) => {
							onAnnotatorsChange(user, isAdd);
						}}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setIsAnnotatorsOpen(false)}>Close</Button>
				</DialogActions>
			</Dialog>
		</Box>
	);
}
